<template>
  <div
    class="form-field"
    :key="fieldKey"
    :class="{
      'empty-lbl': field.type !== FIELD.TYPE.GROUP && !field.lbl,
      'email-templates-field':
        field.id_name?.name == 'emails_email_templates_idb',
      hidden: !!hidden(field) || !!selfHidden(field)
    }"
  >
    <div v-if="field.type === FIELD.TYPE.TXT">
      <span>
        {{ field.value }}
      </span>
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.COMMUNICATION &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <contact-form
        :ref="field.name"
        :field="field"
        :model="form[field.name]"
        :options="field.option.value_type_list"
        :disabled-field="disabled(field) || disabledByAnotherField"
        class="detached-form"
        @save="$emit('save-form')"
      ></contact-form>
      <Button
        buttonSize="big"
        buttonColor="blue"
        buttonText="Добавить контакт"
        @click="addContact"
      />
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.DETAIL_EXPERIENCE &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <detail-experience-form
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field) || disabledByAnotherField"
        :date-format="datepicker.dateFormat"
        class="detached-form"
        @save="$emit('save-form')"
      ></detail-experience-form>
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.EDUCATION &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <Education
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field) || disabledByAnotherField"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.LANGUAGE &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <Language
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field) || disabledByAnotherField"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div v-else-if="field.type === FIELD.TYPE.RECOMENDATION && !hidden(field)">
      <Recomendation
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field)"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.QUALIFICATION &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <Qualification
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name]"
        :disabled-field="disabled(field) || disabledByAnotherField"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>

    <div
      v-else-if="
        field.type === FIELD.TYPE.MULTIARRAY &&
        field.name == FIELD.ID.LANGUAGE_LEVEL &&
        !hidden(field) &&
        !selfHidden(field)
      "
    >
      <LanguageForm
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name] || []"
        :disabled-field="disabled(field) || disabledByAnotherField"
        :is-popup="true"
        :parent-form="form"
        class="detached-form"
        @save="$emit('save-form')"
      />
    </div>
    <div
      v-else-if="
        field.type === FIELD.TYPE.MULTIARRAY &&
        field.name == FIELD.ID.ANOTHER_WORK_PLACE &&
        !hidden(field)
      "
    >
      <AddressForm
        :ref="field.name"
        :field="field"
        :schema="field.schema"
        :model="form[field.name] || []"
        :disabled-field="disabled(field)"
        :is-popup="true"
        :parent-form="form"
        class="detached-form"
        @save="$emit('save-form')"
        @reset-address="resetAddress"
      />
    </div>
    <Photo
      v-else-if="
        field.type === FIELD.TYPE.IMAGE && !hidden(field) && !selfHidden(field)
      "
      :disabled="disabled(field) || disabledByAnotherField"
      :field="field"
      :model="form[field.name]"
      :file="photo_file"
    ></Photo>

    <el-form-item
      v-else-if="
        field.type === FIELD.TYPE.GROUP &&
        !hiddenAll(field.fields) &&
        !selfHidden(field)
      "
      label=""
      :class="[
        'sub-fields',
        hasBoolField(field.fields),
        disabledClass(field),
        field.name == 'superjob_salary_group' ? 'salary_group' : '',
        field.row ? 'column' : ''
      ]"
      label-width="0px"
    >
      <template v-for="it in field.fields">
        <form-row
          v-if="!hidden(it) && !selfHidden(it)"
          :key="it.name"
          :field="it"
          :form="form"
          :module="module"
          :class="subFieldClass(it)"
          :model="form[it.name]"
          :parentId="form.record || ''"
          :options="options[it.name]"
          :callback="callback"
          :field-size="fieldSize || (isPopup ? 'medium' : 'big')"
          :newLabel="it.lbl"
          :noRequiredStar="noRequiredStar"
          :loading="fieldLoading"
          :parentenum="
            dynamicEnumField(it) && it.parentenum ? form[it.parentenum] : ''
          "
          :blocked="blocked[it.name] || selfHidden(it)"
          :visibility-blocked="visibilityBlocked[it.name] || selfBlocked(it)"
          :defaultFirstOption="defaultFirstOption"
          :blockedValues="blockedValues"
          @update-documents-list="updateDocumentsList"
          :search-param="field.search_param ? form[field.search_param] : ''"
          @change-option="selectOption"
          @set-value="setValue"
        ></form-row>
        <div
          v-if="
            it.help_label &&
            !it.help_label.icon &&
            form[it.name] &&
            form[it.name] === it.help_label.value &&
            !(blocked[it.name] || selfHidden(it))
          "
          :key="it.name"
          class="blue fz-14"
        >
          {{ it.help_label.text | format }}
        </div>
        <div
          v-if="
            it.show_sap_help &&
            sapHelps[it.name] &&
            !(blocked[it.name] || selfHidden(it))
          "
          :key="it.name"
          class="blue fz-14"
        >
          {{ sapHelps[it.name] }}
        </div>
      </template>
    </el-form-item>
    <!-- </div> -->
    <div v-else-if="!textType(field.type) && !hidden(field)">
      <!-- условие с префиксом для отступа чекбокса в вакансии, шаблоне (надо переделать и убрать префикс) -->
      <!-- <span
        v-if="
          field.type === FIELD.TYPE.BOOL &&
          prefixClass == 'vacancy' &&
          field.visual_type !== 'no-label'
        "
        class="el-form-item__label"
      >
        <br />
        <br />
      </span> -->

      <FormButtons
        v-if="!hidden(field) && field.type == 'button'"
        :buttons_menu="fillButtonIntent(field)"
        :topPanel="false"
        view-type="detail"
      ></FormButtons>
      <form-row
        v-else-if="!hidden(field)"
        :key="field.name"
        :field="field"
        :form="form"
        :module="module"
        :width="labelWidth"
        :options="options[field.name]"
        :model="form[field.name]"
        :parentId="form.record || ''"
        :callback="callback"
        :datepicker="datepicker"
        :visible-option-btn="visibleOptionBtn"
        :field-size="fieldSize || (isPopup ? 'medium' : 'big')"
        :loading="fieldLoading"
        :blocked="blocked[field.name] || selfHidden(field)"
        :visibility-blocked="
          visibilityBlocked[field.name] || selfBlocked(field)
        "
        :disabled="disabled"
        :noRequiredStar="noRequiredStar"
        :defaultFirstOption="defaultFirstOption"
        :blockedValues="blockedValues"
        :search-param="field.search_param ? form[field.search_param] : ''"
        @add-new-option="addNewOption"
        :parentenum="
          dynamicEnumField(field) && field.parentenum
            ? form[field.parentenum]
            : ''
        "
        @change-option="selectOption"
        @update-documents-list="updateDocumentsList"
        @set-value="setValue"
      ></form-row>
      <div
        v-if="
          field.help_label &&
          !field.help_label.icon &&
          form[field.name] &&
          form[field.name] === field.help_label.value &&
          !(blocked[field.name] || selfHidden(field))
        "
        class="blue fz-14"
      >
        {{ field.help_label.text | format }}
      </div>
      <div
        v-if="
          field.show_sap_help &&
          sapHelps[field.name] &&
          !(blocked[field.name] || selfHidden(field))
        "
        class="blue fz-14"
      >
        {{ sapHelps[field.name] }}
      </div>
      <Divider
        v-if="field.name == 'resume_format'"
        hasLine
        class="form-format__divider"
        dividerSize="16"
      />
      <div
        class="answer-responds"
        v-if="
          field.name === 'answer_responds' &&
          (!inviteAndRefuse.invite || !inviteAndRefuse.refuse)
        "
      >
        <span class="answer-responds__label">
          Автоответы не созданы. Для создания автоответа перейдите в профиль.
        </span>
        <Button
          class="answer-responds__button"
          buttonColor="blue"
          buttonText="Перейти в профиль"
          @click="
            openOldPage(
              `/index.php?module=Users&action=EditView&record=${userId}`
            )
          "
        />
      </div>
      <div class="answer-responds" v-else-if="field.name === 'mass_vacancy'">
        <span class="answer-responds__label fz-14 secondary">
          Откликнувшиеся кандидаты сразу попадают на этап “Добавлен”
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'auto_answer_aspirant'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Сразу после отклика соискатель получит автоматический ответ в чат и на
          почту
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'auto_answer_aspirant_link'"
      >
        <span
          class="answer-responds__label fz-14 secondary"
          style="margin-top: 8px"
        >
          Адрес на сайт, где размещена анкета
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'hide_company_name'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Сделает вакансию анонимной
        </span>
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'free_call_tracking'"
      >
        <span class="answer-responds__label fz-14 secondary">
          Вы увидите пропущенные звонки и получите записи всех разговоров. А
          подменный номер защитит вас от спамеров
        </span>
      </div>

      <div class="answer-responds" v-else-if="field.name === 'get_responds'">
        <div v-if="+form.get_responds">
          <span class="fz-14 secondary">
            Сбор откликов возможен с даты создания публикации или с будущей
            даты.
          </span>
          <div class="answer-responds__date">
            <DatePicker
              :model="form.get_responds_date"
              :field="{ type: 'date', name: 'get_responds_date' }"
              :datepicker="datepicker"
              size="medium"
              :options="pickerOptions"
              @set-value="
                (name, val) => {
                  handleChangeDate(val);
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <el-form-item
      v-else-if="
        textType(field.type) &&
        !hidden(field) &&
        !blocked[field.name] &&
        !selfHidden(field)
      "
      :prop="field.name"
      class="textarea"
      :class="[isEmptyField(field, form[field.name]) ? 'is-empty-field' : '']"
    >
      <span
        v-if="field.visual_type !== 'no-label'"
        class="el-form-item__label"
        :class="{
          'no-required-star':
            field.visual_type == 'no-required-star' || noRequiredStar
        }"
        :style="`line-height: ${
          fieldSize || (isPopup ? 'medium' : 'big') == 'big'
            ? 40
            : fieldSize || (isPopup ? 'medium' : 'big') == 'medium'
            ? 32
            : 24
        }px`"
      >
        {{ field.lbl }}
        <p v-if="field.help && field.icon_help" class="help__text">
          ({{ field.help }})
        </p>
        <p v-if="field.required" class="required-star">*</p>
        <Tooltip
          v-if="field.help_label && field.help_label.icon"
          :content="field.help_label.text"
          class="p-2"
        >
          <Icon iconName="question-circle" iconColor="#0075DB" />
        </Tooltip>
      </span>
      <Editor
        :key="updateKey"
        :name="field.name"
        :value="form[field.name] || form[item.name]"
        :placeholder="field.placeholder || ''"
        :disabled="disabled(field) || disabledByAnotherField"
        :min-length="Number(field.minlength)"
        :max-length="Number(field.maxlength)"
        @change="changeEditorText($event)"
        :class="{ 'email-form__editor': field.type == FIELD.TYPE.EMAIL_BODY }"
        class="editor-field"
      />
      <div v-if="field.show_sap_help && sapHelps[field.name]" class="blue">
        {{ sapHelps[field.name] }}
      </div>
      <div
        class="answer-responds"
        v-else-if="field.name === 'auto_answer_aspirant_text'"
      >
        <span
          class="answer-responds__label fz-14 secondary"
          style="margin-top: 8px"
          v-html="
            `Доступные тэги
          <br/>[myName] — имя рекрутера из профиля, а если оно не указано — email
          <br/>[personName] — имя кандидата, который получит сообщение
          <br/>[vacancy] — название вакансии
          <br/>[resume] — название должности из резюме
          <br/>[link] — ссылка на сайт из поля «Внешняя ссылка»`
          "
        >
        </span>
      </div>
      <template v-if="field['help-bottom']">
        <Link
          v-if="field['help-bottom']?.link"
          class="help__text"
          :style="`color: ${field['help-bottom']?.color || '#21272c'}`"
          :text="field['help-bottom']?.text"
          target="_blank"
          :href="field['help-bottom']?.link"
        />
        <p
          v-else
          v-html="field['help-bottom']?.text"
          class="help__text"
          :style="`color: ${field['help-bottom']?.color || '#21272c'}`"
        ></p>
      </template>
    </el-form-item>
  </div>
</template>

<script>
import { store } from '@/store';
import { FIELD, BUTTON, MODULE } from '@/utils/constants';
import { FormItem } from 'element-ui';
import { dateToMs } from '@/utils/helpers';
import { form, mixin } from '@/utils/mixins';
import AddressForm from 'Elements/AddressForm/AddressForm';
import Button from 'Elements/Button/Button';
import ContactForm from 'Elements/ContactForm/ContactForm';
import DatePicker from 'Elements/DatePicker/DatePicker';
import DetailExperienceForm from 'Elements/DetailExperienceForm/DetailExperienceForm';
import Divider from 'Elements/Divider/Divider';
import Tooltip from 'Elements/Tooltip/Tooltip';
import Editor from 'Elements/Editor/Editor';
import Education from 'Elements/Education/Education';
import FormButtons from 'Elements/Form/FormButtons';
import Language from 'Elements/LanguageForm/Language';
import LanguageForm from 'Elements/LanguageForm/LanguageForm';
import Qualification from 'Elements/Qualification/Qualification';
import Recomendation from 'Elements/Recomendation/Recomendation';
import Photo from 'Elements/Upload/Photo';
import FormRow from './FormRow';
import Link from 'Elements/Link/Link';
// import ExperienceJob from 'Elements/ExperienceJob/ExperienceJob';

export default {
  mixins: [mixin, form],
  props: {
    item: Object,
    form: Object,
    module: String,
    prefixClass: String,
    formSize: { type: String, default: 'mini' },
    fieldSize: { type: String, default: '' },
    isPopup: Boolean,
    labelWidth: String,
    datepicker: Object,
    contactOpts: Object,
    visibleOptionBtn: {
      type: Boolean,
      default: false
    },
    photo_file: Array,
    fieldLoading: Boolean,
    options: Object,
    blocked: Object,
    visibilityBlocked: { type: Object, default: () => ({}) },
    callback: Object,
    noRequiredStar: Boolean,
    defaultFirstOption: {
      type: Boolean,
      default: false
    },
    blockedValues: {
      type: Object
    }
  },
  data() {
    return {
      updateKey: 0,
      field: this.item,
      FIELD,
      BTN: BUTTON,
      MODULE,
      userId: store.state.common.userId,
      defaultDate: null,
      pickerOptions: {
        disabledDate: this.rangeRespondsDate
      }
    };
  },
  created() {
    if (this.field.name === 'get_responds') {
      this.setDateRespond();
    }
  },
  mounted() {
    // предзаполнение номера телефона
    if (
      location.href.indexOf('?prefill_phone=') > -1 &&
      this.field.type === FIELD.TYPE.COMMUNICATION
    ) {
      const phone = location.href.slice(
        location.href.indexOf('?prefill_phone=') + '?prefill_phone='.length
      );

      if (!phone) {
        this.$router.push('/candidates/edit');
        return;
      }

      this.addContact(phone);
    }

    if (this.item.name == 'about_oneself' && !this.form[this.field.name]) {
      this.updateKey++;
    }
  },
  computed: {
    inviteAndRefuse() {
      return store.state.vacancy.inviteAndRefuseText;
    },
    disabledByAnotherField() {
      return (
        this.visibilityBlocked[this.item.name] ||
        this.selfBlocked(this.item) ||
        false
      );
    },
    etalonForm() {
      return store.state.edit.etalonForm || {};
    },
    sapHelps() {
      return store.state.edit.sapHelps;
    },
    fieldKey() {
      return store.state.edit.fieldKey;
    }
  },
  methods: {
    fillButtonIntent(field) {
      const paramMap = {
        email_password: 'email_password',
        mail_smtppass: 'email_password',
        email_user: 'email_user',
        mail_from_name: 'outbound_email_smtp_from_name',
        mail_sendtype: 'email_protocol',
        mail_smtpport: 'outbound_email_mail_smtpport',
        mail_smtpuser: 'email_user',
        outboundtest_from_address: 'email_user',
        outboundtest_to_address: 'email_user',
        port: 'inbound_email_port',
        server_url: 'inbound_email_server_url',
        mail_smtpauth_req: 'outbound_email_mail_smtpauth_req',
        mail_smtpserver: 'outbound_email_mail_smtpserver',
        ssl_enabled: 'inbound_email_ssl_enabled',
        calendar_login: 'outlook_login',
        calendar_password: 'outlook_password',
        calendar_server: 'outlook_server',
        mail_smtpssl: 'outbound_email_mail_smtpssl'
      };

      const result = JSON.parse(JSON.stringify(field));

      if (field?.intents[0]?.request?.request_params) {
        const params = field.intents[0].request.request_params;
        for (let key in params) {
          const mappedKey = paramMap[key];
          const formValue = this.form[mappedKey] || params[key] || '';

          result.intents[0].request.request_params[key] =
            this.form['email_protocol'] == 'HTTPS'
              ? key == 'mail_smtpport' || key == 'mail_smtpssl' || key == 'port'
                ? '0'
                : key == 'ssl_enabled'
                ? '/ssl'
                : key == 'mail_smtpauth_req'
                ? '1'
                : key == 'mail_smtpserver' || key == 'server_url'
                ? this.form['https_server']
                : formValue
              : formValue;
        }
      }

      if (field?.intents[0]?.request?.dynamic_request_params) {
        const params = field.intents[0].request?.dynamic_request_params;
        for (let key in params) {
          const mappedKey = paramMap[key];
          const formValue = this.form[mappedKey] || params[key] || '';

          result.intents[0].request.dynamic_request_params[key] = formValue;
        }
      }

      return [[result]];
    },
    openOldPage(url) {
      this.$router.push({
        name: '*',
        params: {
          url: url
        }
      });
    },
    handleChangeDate(val) {
      this.$set(this.form, 'get_responds_date', val);

      if (dateToMs(this.defaultDate.toLocaleDateString()) < dateToMs(val)) {
        this.$set(this.form, 'nextDate', true);
      }
    },
    updateDocumentsList() {
      this.$emit('update-documents-list');
    },
    setDateRespond() {
      if (this.form.published_at) {
        const date =
          this.form?.get_responds == 1
            ? this.form?.get_responds_date
            : this.form?.published_at;

        this.defaultDate = this.getNewDate(date);
      } else {
        this.defaultDate = new Date();
      }
    },
    rangeRespondsDate(time) {
      const format = 'DD.MM.YYYY HH:mm';
      let date = this.form?.published_at
        ? this.rawDate(this.form.published_at, format)
        : new Date();
      date = new Date(date.setDate(date.getDate() - 1));
      return time.getTime() <= date;
    },
    disabledClass(field) {
      return this.disabled(field) ? 'sub-fields--disabled' : '';
    },
    subFieldClass(field) {
      const selectType = this.selectType(field.type);
      const className = selectType
        ? `el-select el-select--${this.formSize}`
        : `el-input el-input--${this.formSize}`;

      return [className /*this.disabled(field) ? 'is-disabled' : ''*/];
    },
    hasBoolField(fields) {
      return fields &&
        Array.isArray(fields) &&
        fields.find(item => item.type === FIELD.TYPE.BOOL)
        ? 'sub-fields--max'
        : '';
    },
    hiddenAll(fields) {
      return fields.every(field => this.hidden(field));
    },
    selectOption(...params) {
      this.$emit('change-option', ...params);
    },
    setValue(name, val, blocked, trigger) {
      this.$emit('set-value', name, val, blocked, trigger);

      if (name === 'get_responds' && val === '1') {
        const date = this.form?.published_at?.split(' ')[0] || null;
        const dateParts = date?.split('-');
        this.$set(
          this.form,
          'get_responds_date',
          (this.form?.published_at
            ? date.includes('-')
              ? `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`
              : date
            : '') ||
            this.formatDate(this.defaultDate, this.datepicker.dateFormat)
        );
      }
    },
    addNewOption(name) {
      this.$emit('add-new-option', name);
    },
    addContact(value = '') {
      store.commit('common/addContact', {
        opts: this.field.option.value_type_list,
        value
      });
    },
    changeEditorText(data) {
      this.setValue(this.field.name, data, this.field.blocked, true);
    },
    selfBlocked(field) {
      if (!field.self_blocked) return;
      return field.self_blocked.some(item =>
        Object.keys(item).every(f => {
          const val = this.form[f] || '';
          return (
            (item[f] === '%not_empty%' && this.form[f]) ||
            (Array.isArray(item[f])
              ? item[f].length == 1
                ? val === item[f][0]
                : item[f].every(v => Array.isArray(val) && val.includes(v))
              : val === item[f])
          );
        })
      );
    },
    selfHidden(field) {
      // !^<id> скрываем если значение не равно айдишнику
      // '!^' скрываем если не равно пустоте

      if (!field.self_hidden) return;
      const hidden = field.self_hidden.some(item =>
        Object.keys(item).every(f => {
          const val =
            Array.isArray(this.form[f]) && !this.form[f].length
              ? ''
              : this.form[f] || '';

          return Array.isArray(item[f])
            ? item[f].every(v => {
                return v.indexOf('!^') == 0
                  ? Array.isArray(this.form[f]) && val
                    ? !val.includes(v.replace('!^', ''))
                    : v.replace('!^', '') !== val
                  : val === v;
              })
            : item[f].indexOf('!^') == 0
            ? Array.isArray(this.form[f]) && val
              ? !val.includes(item[f].replace('!^', ''))
              : item[f].replace('!^', '') !== val
            : val === item[f];
        })
      );

      if (hidden) {
        const val = this.item?.default
          ? this.formatHtml(this.item?.default)
          : Array.isArray(this.form[field.name])
          ? []
          : '';
        if (
          (Array.isArray(this.form[field.name])
            ? !!this.form[field.name].length
            : !!this.form[field.name]) &&
          !field.hidden_prefill_accept
        ) {
          this.setValue(field.name, val, field.blocked);
        }

        if (field.dynamic_request && this.etalonForm[field.name] !== val) {
          store.commit('edit/setEtalonForm', {
            [field.name]: val
          });

          if (this.item.id_name) {
            store.commit('edit/setEtalonForm', {
              [this.idFieldName(field.id_name)]: ''
            });
          }
        }

        if (field.id_name && !field.hidden_prefill_accept) {
          this.setValue(this.idFieldName(field.id_name), '');
        }

        if (this.sapHelps[field.name] && field.show_sap_help) {
          // прячем подсказку при скрытии поля по задаче HRCRMSM-810
          store.commit('edit/setSapHelp', { key: field.name, val: '' });
        }
      }

      return hidden;
    },
    resetAddress() {
      this.$set(this.form, 'work_place', '');
    }
  },
  components: {
    'el-form-item': FormItem,
    FormRow,
    Editor,
    Photo,
    Button,
    ContactForm,
    DetailExperienceForm,
    Education,
    Language,
    Qualification,
    DatePicker,
    LanguageForm,
    Divider,
    Tooltip,
    AddressForm,
    FormButtons,
    Recomendation,
    Link
    // ExperienceJob
  }
};
</script>

<style lang="scss">
.el-textarea__inner {
  &:hover {
    background-color: $black-10 !important;

    &:after {
      background-color: $black-10 !important;
    }
  }
}

.answer-responds {
  display: flex;
  flex-direction: column;

  &__date {
    width: 150px;
    margin-top: 2px;
  }

  &__label {
    font-size: 16px;
    line-height: 24px;
    color: $black-100;
    margin-bottom: 8px;
    word-break: break-word;
  }

  &__button {
    width: 171px;
  }
}

.sub-fields {
  &--max {
    .el-form-item:first-child {
      margin-right: 32px;
    }
  }

  & > .el-form-item__content {
    display: flex;

    & > .el-form-item {
      margin-bottom: 0;
    }

    & > .el-form-item:not(:first-child) {
      margin-left: 8px !important;
    }
  }
}

.salary_group {
  & > .el-form-item__content {
    & > .el-form-item:not(:first-child) {
      margin-left: 12px !important;
    }

    .row:first-child {
      width: 214px !important;
      margin-right: 12px;
    }

    .row:nth-child(2) {
      width: 214px !important;
      margin-right: 12px;
    }

    .row:last-child {
      width: 140px !important;
    }
  }
}

.el-form-item__label {
  color: $black-200;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;

  .help__text {
    display: inline;
    color: $black-80;
    margin-left: 4px;
  }

  .required-star {
    display: inline;
    color: $red;
  }
}

.column {
  ::after,
  ::before {
    content: none;
  }

  & > .el-form-item__content {
    flex-direction: column;
    gap: 12px;
  }
}

.editor-field + a.hyperlink.help__text:hover span,
.textarea + a.hyperlink.help__text:hover span,
.editor-field + p.help__text:hover span,
.textarea + p.help__text:hover span {
  color: inherit !important;
}
</style>

<style lang="scss" scoped>
.form-format__divider {
  margin-bottom: 16px;
}
.textarea {
  & ::v-deep .el-form-item__label {
    color: $black-200;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    display: flex;

    .help__text {
      display: inline;
      color: $black-80;
      margin-left: 4px;
    }
  }
}
.form-field {
  &.email-templates-field {
    margin-left: 66px;
  }
}
.email-form__editor ::v-deep .ck-content {
  min-height: 144px;
}
</style>
